import { z } from "zod";

import { emailSchema } from "~/screens/Auth/schemas/email.schema";

export const loginEmailSchema = z.object({
  email: emailSchema,
});

export const loginPasswordSchema = z.object({
  password: z.string(),
});
